import { render, staticRenderFns } from "./ProcedimentosSolicitados.vue?vue&type=template&id=572e4722&scoped=true&"
import script from "./ProcedimentosSolicitados.vue?vue&type=script&lang=js&"
export * from "./ProcedimentosSolicitados.vue?vue&type=script&lang=js&"
import style0 from "./ProcedimentosSolicitados.vue?vue&type=style&index=0&id=572e4722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e4722",
  null
  
)

export default component.exports